import React, { Component } from 'react'

import '../scss/ZoomControl.scss'


class ZoomControl extends Component {
  
  getDisplayedPercentage () {
    return `${Math.round(this.props.scale * 100)}%`
  }
  
  render () {
    return (
      <div className="ZoomControl">
        <div className="ZoomControl-zoom-out">
          <button type="button" onClick={this.props.onZoomOut}>&ndash;</button>
        </div>
      
        <div className="ZoomControl-current">
          {this.getDisplayedPercentage()}
        </div>
        <div className="ZoomControl-zoom-in">
        <button type="button" onClick={this.props.onZoomIn}>+</button>
        </div>
      </div>
    )
  }
}

export default ZoomControl
